import { observable, action } from "mobx";
import { DeleteUserInfo } from "../../../api/typings/Users";
import { uiStore } from "../UiStore/UiStore";
import { FiltersQuerySerialized } from "../../../helpers/serializers/filters";
import { UserRoleEnum } from "../../../static/enums/UserRole";
import { PageQuery } from "../../../api/users/UsersApi";
import { BaseUserStore } from "../../baseStores/BaseUserStore";
import { createObservableFromBaseUser } from "../../createMakeObservable";

export type GetUsersData = Partial<PageQuery> &
  Partial<FiltersQuerySerialized> & {
    "filter[role]"?: UserRoleEnum;
    with_trashed?: "0" | "1";
  };

export interface Page {
  current_page: number;
  per_page: number;
  from: number;
  to: number;
  total: number;
  last_page: number;
}

class TableStore extends BaseUserStore {
  page: Page = {
    current_page: 1,
    from: 1,
    to: 15,
    total: 15,
    last_page: 1,
    per_page: 15,
  };

  autoLoginUrls: Record<string, string> = {};

  constructor() {
    super();
    createObservableFromBaseUser<TableStore>(this, {
      page: observable,
      autoLoginUrls: observable,
      setTablePage: action,
    });
    // makeObservable<TableStore>(this, {
    //   page: observable,
    // });
  }

  deleteUser = async (data: DeleteUserInfo) => {
    try {
      uiStore.startPending();
      const { users } = await this.userService.deleteUser(data);
      this.setUsers(users);
      uiStore.notify({ message: "Пользователь удален!", options: { variant: "success" } });
      await this.getUsers({
        "page[size]": this.page.per_page.toString(),
        "page[number]": this.page.current_page.toString(),
      });
    } catch (e) {
      uiStore.notify({
        message: "Произошла ошибка! Попробуйте перезагрузить страницу и попробовать ещё раз.",
        options: { variant: "error" },
      });
    } finally {
      uiStore.stopPending();
    }
  };

  getUsers = async (data: GetUsersData) => {
    try {
      uiStore.startPending();
      const resources = await this.userService.getUsers(data);
      const { page, autoLoginUrls } = resources;
      this.autoLoginUrls = { ...this.autoLoginUrls, ...autoLoginUrls };
      this.setTablePage(page!);
      this.setResources(resources);
    } catch (e) {
      uiStore.notify({
        message: "Произошла ошибка! Попробуйте перезагрузить страницу.",
        options: { variant: "error" },
      });
    } finally {
      uiStore.stopPending();
    }
  };

  setTablePage = (page: Partial<Page>) => {
    this.page = { ...this.page, ...page };
  };
}

export const tableStore = new TableStore();
